import { PRODUCT_STORE_ACTION, PRODUCT_STORE_COMMIT, PRODUCT_STORE_GETTER } from "../store/product-store";

export const productMixin = {


	data() {
		return {
			productSpinner: false, 

		};
	},

	computed: {

		productGroupList() {
			const productGroupList = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_GROUP_LIST];

			return productGroupList;

		},

		productGroup() {
			const key = this.searchProductConfig?.productGroupKey

			const productGroup = this.productGroupList?.find(productGroup => productGroup.key == key)

			return productGroup
		},

		favoriteProductIdList() {
			return this.$store.getters[PRODUCT_STORE_GETTER.FAVORITE_PRODUCT_ID_LIST];
		},

		outletProductIdList(){
			return this.$store.getters[PRODUCT_STORE_GETTER.OUTLET_PRODUCT_ID_LIST]
		}


	},

	methods: {

		formatPrice(product, data){

			if (!data){
				data = {};
			}

			if (!data.kr){
				data.kr = "kr";
			}

			var price = product.price2

			if (product?.productOptionData?.count > 0){

				if (product?.productOptionData?.price2Min > 0 && product?.productOptionData?.price2Min != product?.productOptionData?.price2Max){
					price = product?.productOptionData?.price2Min + "-" + product?.productOptionData?.price2Max;
				}else{
					price = product?.productOptionData?.price2Max
				}
				

			}

			return "" + price + "\xa0" + data.kr + "";
		},

		formatPrice1(price1, data){
			if (!data) {
				data = {};
			}

			if (!data.kr) {
				data.kr = "kr";
			}

			if (price1){
				return "" + price1 + "\xa0" + data.kr + "";
				//
			}

			return "--- kr"

		},

		formatArtnr(artnr){
			if (!artnr){
				return "";
			}

			if (artnr?.toUpperCase()?.startsWith("PO-")){
				return "\xa0";
			}
			
			return "" + artnr + "";
		},

		isFavorite(productId) {
			return this.favoriteProductIdList?.includes(parseInt(productId));
		},

		isOutlet(productId){
			return this.outletProductIdList?.includes(parseInt(productId));
		},


		getProductRowList() {

	

			this.productSpinner = true;

			this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_ROW_LIST, data: { background: false } }).then(() => {
				this.getProductRowListComplete()
				
			}).finally(() => {
				this.productSpinner = false;
			})
		},

		getProductRowListComplete(){
			// override 
		},

		getProductDetails({productId}) {
			this.productSpinner = true;

			this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_DETAILS, data: { productId: productId, background: false } }).then(() => {
				this.getProductDetailsComplete()
			}).finally(() => {
				this.productSpinner = false;
			})
		},

		getProductDetailsComplete() {
			// override 
		},

		toggleFavorite(productId) {

			productId = parseInt(productId);

			const productIdList = this.$store.getters[PRODUCT_STORE_GETTER.FAVORITE_PRODUCT_ID_LIST];

			if (productIdList.includes(productId)) {
				this.$store.commit(PRODUCT_STORE_COMMIT.REMOVE_PRODUCT_ID_FROM_PRODUCT_GROUP, { productId: productId, key: "FAVORITE" });

			} else {
				this.$store.commit(PRODUCT_STORE_COMMIT.ADD_PRODUCT_ID_TO_PRODUCT_GROUP, { productId: productId, key: "FAVORITE" });
			}




		}





	}
}



